import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { AdminService } from '../../services/admin.service';

@Component({
    selector: 'app-admin-translate',
    templateUrl: './admin-translate.component.html',
    styleUrls: ['./admin-translate.component.scss', '../admin-main.common.scss'],
    standalone: false
})
export class AdminTranslateComponent implements OnInit {
  companyForm = this.fb.group({
    name: [{ value: '', disabled: true }],
    preferences: this.fb.group({
      translations: this.fb.group({
        address: 'Dirección',
        address_plural: 'Direcciones',
        aditional: 'Adicional',
        aditional_plural: 'Adicionales',
        amount: 'Precio',
        amount_plural: 'Precios',
        analytics: 'Analíticas',
        booking_plural: 'Agendamientos',
        booking: 'Agendamiento',
        budget: 'Presupuesto',
        budget_plural: 'Presupuestos',
        calendar: 'Calendario',
        calendar_plural: 'Calendarios',
        cash: 'Efectivo',
        cash_plural: 'Efectivos',
        category: 'Grupo de Items',
        category_plural: 'Categorías',
        check_in: 'Orden',
        checkin_plural: 'Recepciones',
        cheque: 'Cheque',
        cheque_plural: 'Cheques',
        checkin: 'Recepción',
        client_plural: 'Clientes',
        client: 'Cliente',
        client_identifier: 'RUT',
        comment: 'Comentario',
        comment_plural: 'Comentarios',
        credit_card: 'Tarjeta de Crédito',
        credit_card_plural: 'Tarjetas de Crédito',
        credit_note: 'Nota de Crédito',
        credit_note_plural: 'Notas de Crédito',
        credit_note_return: 'Nota Crédito Devolución',
        credit_note_return_plural: 'Notas Crédito Devolución',
        crm: 'CRM',
        crm_plural: 'CRMs',
        'crm/booking': 'CRM Retención',
        'crm/booking_plural': 'CRM Retención',
        'crm/marketing': 'CRM Marketing',
        'crm/marketing_plural': 'CRM Marketing',
        'crm/absence': 'CRM Inasistencias',
        'crm/absence_plural': 'CRM Inasistencias',
        currency_prefix: '$',
        currency_suffix: '',
        customer_relationship: 'Gestión de Clientes',
        debit_card: 'Tarjeta de Débito',
        debit_card_plural: 'Tarjetas de Débito',
        debit_note: 'Nota de Débito',
        debit_note_plural: 'Notas de Débito',
        electronic_invoice: 'Factura Electrónica',
        electronic_invoice_plural: 'Facturas Electrónicas',
        electronic_ticket: 'Boleta Electrónica',
        electronic_ticket_plural: 'Boletas Electrónicas',
        financial_movement: 'Movimiento',
        financial_movement_plural: 'Movimientos',
        'financial_movement/change': 'Vuelto',
        'financial_movement/change_plural': 'Vueltos',
        'financial_movement/prepayment': 'Abono',
        'financial_movement/prepayment_plural': 'Abonos',
        'financial_movement/payment': 'Pago',
        'financial_movement/payment_plural': 'Pagos',
        'financial_movement/refund': 'Reembolso',
        'financial_movement/refund_plural': 'Reembolsos',
        'financial_movement/expense': 'Gasto',
        'financial_movement/expense_plural': 'Gastos',
        folder: 'Carpeta',
        folder_plural: 'Carpetas',
        'folder/inventory_action/pricing': 'Carpeta de Cotizaciones',
        'folder/inventory_action/pricing_plural': 'Carpetas de Cotizaciones',
        inventory: 'Inventario',
        inventory_plural: 'Inventarios',
        'inventory_action/buy_order': 'Orden de Compra',
        'inventory_action/buy_order_plural': 'Órdenes de Compra',
        'inventory_action/consume_plural': 'Consumos de Inventario',
        'inventory_action/consume': 'Consumo de Inventario',
        'inventory_action/loss_plural': 'Pérdidas de Inventario',
        'inventory_action/loss': 'Pérdida de Inventario',
        'inventory_action/movement_plural': 'Movimientos de Inventario',
        'inventory_action/movement': 'Movimiento de Inventario',
        'inventory_action/pricing_plural': 'Solicitudes de Cotización',
        'inventory_action/pricing': 'Solicitud de Cotización',
        'inventory_action/return_plural': 'Devoluciones de Inventario',
        'inventory_action/return': 'Devolución de Inventario',
        'inventory_action/set_plural': 'Ajuste de Inventario',
        'inventory_action/set': 'Ajustes de Inventario',
        'inventory_action/stock_plural': 'Cotizaciones de Repuestos',
        'inventory_action/stock': 'Cotización de Repuestos',
        'inventory_action/edit_plural': 'Intercambios de Inventario',
        'inventory_action/edit': 'Intercambio de Inventario',
        inventory_action_plural: 'Acciones de Inventario',
        inventory_action: 'Accion de Inventario',
        invoice: 'Factura',
        invoice_plural: 'Facturas',
        'invoice/purchase': 'Factura de Compra',
        'invoice/purchase_plural': 'Facturas de Compra',
        'invoice/sale': 'Factura de Venta', 
        'invoice/sale_plural': 'Facturas de Venta', 
        'invoice/credit_note': 'Nota de Crédito', 
        'invoice/credit_note_plural': 'Notas de Crédito',
        invoicing: 'Facturación',
        location: 'Local',
        location_plural: 'Locales',
        object_identifier: 'Patente',
        object_plural: 'Vehículos',
        object: 'Vehículo',
        order_plural: 'Ordenes de Trabajo',
        order: 'Orden de Trabajo',
        order_comment: 'Comentario',
        order_comment_plural: 'Comentarios',
        others: 'Otros',
        payment_method: 'Método de Pago',
        payment_method_plural: 'Métodos de Pago',
        pending_works: 'Trabajos Pendientes',
        phone: 'Teléfono',
        phone_plural: 'Teléfonos',
        product: 'Producto',
        product_plural: 'Productos',
        professional_plural: 'Profesionales',
        professional: 'Profesional',
        provider_plural: 'Proveedores',
        provider: 'Proveedor',
        quantity: 'Cantidad',
        requirement: 'Solicitud',
        requirement_plural: 'Solicitudes',
        service_detail: 'Detalle de Servicio',
        service_detail_plural: 'Detalles de Servicio',
        tax: 'IVA',
        total: 'Total',
        total_plural: 'Totales',
        transfer: 'Transferencia',
        transfer_plural: 'Transferencias',
        user_assignation: 'Asignado',
        user_assignation_plural: 'Asignados',
        user_device: 'Dispositivo',
        user_device_plural: 'Dispositivos',
        value: 'Valor',
        value_plural: 'Valores',
        warehouse: 'Bodega',
        warehouse_plural: 'Bodegas',
        web_pay: 'WebPay',
        work_assignation: 'Trabajo',
        work_assignation_plural: 'Trabajos',
        work_request: 'Trabajo Requerido',
        work_request_plural: 'Trabajos Requeridos',
      }),
    }),
    email: [{ value: '', disabled: true }],
    domain: [
      { value: '', disabled: true },
      Validators.pattern(
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/,
      ),
    ],
  });

  constructor(
    private fb: UntypedFormBuilder,
    private companyService: AdminService,
  ) { }

  ngOnInit(): void {
    this.companyService.setupApp().toPromise().then((response) => {
      this.companyForm.patchValue(response.body);
    }).catch((error) => {
      console.error(error);
    });
    this.companyForm.valueChanges.pipe(debounceTime(2000)).subscribe((value) => {
      if (this.companyForm.valid) {
        this.companyService.updateCompany(value).subscribe();
      }
    });
  }

  getTrans() {
    return <FormGroup> this.companyForm.get('preferences.translations');
  }
}
